import { z } from 'zod';
export const TaxIdSchema = z.string().regex(/^\d{13}$/, 'Tax ID must be 13 digits');
export const CompanyCodeSchema = z.enum(['DCC', 'TTOP', 'RCI']);
export const CompanySchema = z.object({
    // Optional in the schema so the static COMPANIES seed const (which has no DB id)
    // still satisfies parse(); the DB-row form populated by Prisma includes a UUID.
    id: z.uuid().optional(),
    code: CompanyCodeSchema,
    nameTh: z.string(),
    nameEn: z.string(),
    taxId: TaxIdSchema,
    color: z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Color must be a 6-digit hex (e.g. #C00000)'),
});
export const COMPANIES = [
    {
        code: 'DCC',
        nameTh: 'บริษัท ไดนาสตี้ เซรามิค จำกัด (มหาชน)',
        nameEn: 'Dynasty Ceramic Public Co., Ltd.',
        taxId: '0107537000742',
        color: '#C00000',
    },
    {
        code: 'TTOP',
        nameTh: 'บริษัท ไทล์ท้อป อินดัสตรี้ จำกัด (มหาชน)',
        nameEn: 'Tiletop Industry Public Co., Ltd.',
        taxId: '0107538000681',
        color: '#203764',
    },
    {
        code: 'RCI',
        nameTh: 'บริษัท โรแยล ซีรามิค อุตสาหกรรม จำกัด (มหาชน)',
        nameEn: 'Royal Ceramic Industry Public Co., Ltd.',
        taxId: '0107537001137',
        color: '#7030A0',
    },
];
//# sourceMappingURL=company.js.map